// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610081705/js/" + chunkId + "." + {"44":"7ee7654c","225":"68ebe958","481":"7e7727a7","486":"0f8a1d4f","770":"bad3d207"}[chunkId] + ".0.946691479943431.chunk.js";
};